module.exports = __webpack_public_path__ + "static/img/son4.7cc4a394.png";